export const siteListSchema = {
	title: 'LMS Site List',
	description: 'Schema for all siteList listing',
	version: 0,
	primaryKey: 'sfid',
	type: 'object',
	properties: {
		id: { type: 'number' },
		sfid: { type: 'string', maxLength: 250 },
		name: { type: 'string' },
		site_location_c: { type: 'string' },
		latitude: { type: 'number' },
		longitude: { type: 'number' },
		pincode_c: { type: ['string', 'null'], default: null },
		address_c: { type: ['string', 'null'], default: null },
		end_user_phone_c: { type: ['string', 'null'], default: null },
		end_user_name_c: { type: ['string', 'null'], default: null },
		applicatorname_c: { type: ['string', 'null'], default: null },
		applicator_phone_number_text_c: { type: ['string', 'null'], default: null },
		site_sub_type_c: { type: 'string' },
		solvent_used_c: { type: ['string', 'null'], default: null },
		fevicol_business_potential_c: { type: ['string', 'null'], default: null },
		epoxy_adhesive_used_c: { type: ['string', 'null'], default: null },
		competition_brand_c: { type: ['string', 'null'], default: null },
		lastactivitydate: { type: 'string' },
		last_updated_on_tsi_cmdi_asi_c: { type: ['string', 'null'], default: null },
		next_scheduled_visit_date: { type: ['string', 'null'], default: null },
		whom_did_you_meet_c: { type: 'string' },
		site_current_status_c: { type: 'string' },
		convert_status: { type: 'boolean' },
		priority: { type: 'number' },
		is_fcc_contactor: { type: 'boolean' },
		site_priority: { type: ['number', 'null'], default: null },
		source: { type: ['string', 'null'], default: null }, // Site Specialist code
		current_stage_of_site_c: { type: ['string', 'null'], default: null },
		reason_sitelose_lost_competition_c: { type: ['string', 'null'], default: null },
		createddate: { type: ['string', 'null'], default: null }, // Added
		glue_consumed_as_of_last_visit_date: { type: ['string', 'null'], default: null },
		conversion_volume: { type: ['string', 'null'], default: null },
		brand_converted: { type: ['string', 'null'], default: null },
		date_of_next_visit: { type: ['string', 'null'], default: null },
		glueconsumedtilldate_c: { type: ['string', 'null'], default: null },
		date_of_visit: { type: ['string', 'null'], default: null },
		adopted_site: { type: 'boolean' },
		membership_no_c: { type: ['string', 'null'], default: null },
		lead_status: { type: ['string', 'null'], default: null },
		lead_membership_no_c: { type: ['string', 'null'], default: null },
	},
	required: [
		'id',
		'sfid',
		'name',
		'site_location_c',
		'latitude',
		'longitude',
		'site_sub_type_c',
		'priority',
		'site_current_status_c',
	],
};
